export enum PlatformInviteStatus {
    active = 'ACTIVE',
    expired = 'EXPIRED',
    cancelled = 'CANCELLED',
    accepted = 'ACCEPTED',
}